import { useEffect, useState } from "react";
import { Ban, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const OrdersTab = () => {
  const [orders, setOrders] = useState(null);

  const load = () =>
    api.get("/admin/orders").then((r) => setOrders(r.data)).catch((e) => toast.error(formatApiError(e)));

  useEffect(() => {
    load();
  }, []);

  const setStatus = async (o, status) => {
    try {
      await api.patch(`/admin/orders/${o.id}`, { status });
      toast.success(`Ordine ${status === "attivo" ? "riattivato" : "annullato"}`);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (!orders) {
    return <div className="h-10 w-10 animate-spin rounded-full border-2 border-amber-400/30 border-t-amber-400" />;
  }

  return (
    <div className="overflow-x-auto rounded-2xl border border-amber-500/20" data-testid="orders-tab">
      <table className="w-full min-w-[760px] text-left text-sm">
        <thead>
          <tr className="border-b border-amber-500/15 bg-[#0C241A]/70 text-xs uppercase tracking-wider text-amber-300/80">
            <th className="px-5 py-3.5">Codice</th>
            <th className="px-5 py-3.5">Cliente</th>
            <th className="px-5 py-3.5">Tipo</th>
            <th className="px-5 py-3.5">Prezzo</th>
            <th className="px-5 py-3.5">Stato</th>
            <th className="px-5 py-3.5">Attivato da</th>
            <th className="px-5 py-3.5">Data</th>
            <th className="px-5 py-3.5 text-right">Azioni</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 && (
            <tr><td colSpan={8} className="px-5 py-10 text-center text-emerald-100/50">Nessun ordine ancora.</td></tr>
          )}
          {orders.map((o) => (
            <tr key={o.id} data-testid={`admin-order-${o.code}`} className="border-b border-amber-500/10 text-emerald-100/85">
              <td className="px-5 py-3.5 font-mono font-bold text-amber-100">{o.code}</td>
              <td className="px-5 py-3.5">
                <p className="font-semibold">{o.user_name}</p>
                <p className="text-xs text-emerald-100/50">{o.user_email}</p>
              </td>
              <td className="px-5 py-3.5">{o.kind === "gift" ? "Regalo" : "Personale"}</td>
              <td className="px-5 py-3.5">€ {o.price.toFixed(2).replace(".", ",")}</td>
              <td className="px-5 py-3.5">
                <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider ${o.status === "attivo" ? "bg-emerald-400/15 text-emerald-300" : "bg-red-400/15 text-red-300"}`}>
                  {o.status}
                </span>
              </td>
              <td className="px-5 py-3.5 text-xs text-emerald-100/60">{o.redeemed_by_email || "—"}</td>
              <td className="px-5 py-3.5 text-emerald-100/60">{new Date(o.created_at).toLocaleDateString("it-IT")}</td>
              <td className="px-5 py-3.5 text-right">
                <button
                  type="button"
                  data-testid={`order-toggle-${o.code}`}
                  onClick={() => setStatus(o, o.status === "attivo" ? "annullato" : "attivo")}
                  className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold ${
                    o.status === "attivo"
                      ? "border-red-400/40 text-red-300 hover:bg-red-400/10"
                      : "border-emerald-400/40 text-emerald-300 hover:bg-emerald-400/10"
                  }`}
                >
                  {o.status === "attivo" ? <Ban className="h-3.5 w-3.5" /> : <CheckCircle2 className="h-3.5 w-3.5" />}
                  {o.status === "attivo" ? "Annulla" : "Riattiva"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
